import React, { Component } from 'react';
import {
    ExportOutlined
} from '@ant-design/icons';
import {
    Button,
    Modal,
    Select
} from 'antd';
import { Api } from '../../../lib/api';

import fileDownload from 'js-file-download';
import axios from 'axios';

import TestBlockResults from './TestBlockResults';
import { hexEncode } from '../../../lib/utils';

const { Option, OptGroup } = Select;

class DataBrowserResultsModal extends Component {
    state = {
        selectedDut: this.props.selectedDut,
        serialNumber: this.props.serialNumber,
        xlsxLoading: false,
        labelId: null,
        dutId: null,
        cableCoreSize: null,
        testPlanId: null,
        labels: [],
        testBlockResults: this.props.testBlockResults,
        allExcelLabels: [],
        labelVisible: false
    };

    close = () => {
        this.props.close();
    }
    async loadFields() {
        await Api.getResult(this.state.testBlockResults[0].id).then((results) => {
            let cableCoreSize = results[0].testBlock.cableCoreSize;
            let testPlanId = results[0].rawResults.testPlan;
            let testResults = results[0].testResults;
            let serialNum = results[0].testDut.serialNumber;
            let dutId = results[0].testDutId;
            this.setState(
                { 
                    cableCoreSize: cableCoreSize,
                    testPlanId: testPlanId,
                    testResults: testResults,
                    serialNum: serialNum,
                    dutId: dutId
                }
            )
        })
    }

    render() {
        return(
            <Modal
                title={`Results for ${this.state.serialNumber}`}
                wrapClassName="test-block-results-modal"
                open={this.state.selectedDut !== null}
                destoryOnClose={true}
                mask={true}
                closable={true}
                onCancel={this.close}
                bodyStyle={{ maxHeight: '70vh', transition: 'height 0.3s ease' }}
                footer={
                    <Button type="primary" onClick={() => this.props.close()}>
                        Close
                    </Button>
                }
                width={1500}
            >
                <>
                    {this.state.labelVisible && (
                        <Modal
                            title="Export Label"
                            open={this.state.labelVisible}
                            onCancel={() => this.setState({ labelVisible: false })}
                            footer={
                                <div className="footer">
                                    <div className="buttons">
                                        <Button
                                            type="primary"
                                            disabled={this.state.labelId === null}
                                            loading={this.state.xlsxLoading}
                                            onClick={async () => {
                                                await this.loadFields();
                                                if (typeof this.state.labelId === 'number') {
                                                    this.setState({ xlsxLoading: true });
                                                    Api.getLabelPdfData(
                                                        this.state.labelId,
                                                        this.state.dutId,
                                                        this.state.testBlockResults[0].id,
                                                        this.state.cableCoreSize,
                                                        this.state.testPlanId
                                                    ).then((res) => {
                                                        this.props.openInNewTab(res);
                                                        this.setState({ labelVisible: false, labels: [], labelId: null, xlsxLoading: false });
                                                    });
                                                } else {
                                                    this.setState({ xlsxLoading: true });
                                                    try {
                                                        Api.getXlsxDownloadUrl({
                                                            filterParams: {
                                                                serialNumber: hexEncode(this.state.serialNum),
                                                                testPlanId: this.state.testPlanId,
                                                                excelLabel: this.state.labelId,
                                                                testDate: {}
                                                            },
                                                            excel: true,
                                                            detailed: true,
                                                            fileName: this.state.serialNum
                                                        }).then(async (res1) => {
                                                            await axios
                                                                .get(res1, {
                                                                    responseType: 'blob'
                                                                })
                                                                .then(async (res) => {
                                                                    await fileDownload(res.data, this.state.serialNum + '.xlsx');
                                                                    this.setState({
                                                                        labelVisible: false,
                                                                        xlsxLoading: false,
                                                                        labelId: null
                                                                    });
                                                                });
                                                        });
                                                    } catch (error) {
                                                        this.setState({
                                                            labelVisible: false,
                                                            xlsxLoading: false,
                                                            labelId: null
                                                        });
                                                        alert(error);
                                                    }
                                                }}}
                                        >
                                            Export
                                        </Button>
                                        <Button
                                            onClick={() => {
                                                this.setState({ labelVisible: false });
                                            }}
                                        >
                                            Cancel
                                        </Button>
                                    </div>
                                </div>
                            }
                        >
                            <>
                                <div>Select a label:</div>

                                <Select
                                    value={this.state.labelId}
                                    onChange={(labelId) => {
                                        if (labelId) {
                                            this.setState({
                                                labelId
                                            });
                                        }
                                    }}
                                    style={{ width: '350px' }}
                                >
                                    <Select.Option value={null}></Select.Option>
                                    {this.state.labels.map((label) => (
                                        <Select.Option key={label.id} value={label.id}>
                                            {label.name}
                                        </Select.Option>
                                    ))}

                                    <OptGroup label="Excel Labels">
                                        {Object.values(this.state.allExcelLabels).map((label, index) => (
                                            <Option key={index + 'key'} value={label}>
                                                {label}
                                            </Option>
                                        ))}
                                    </OptGroup>
                                </Select>
                            </>
                        </Modal>
                    )}
                </>
                <div>
                    <div style={{textAlign: 'right', marginBottom: '10px', marginTop: '-15px', marginRight: '10px'}}>
                        <Button onClick={async () => {
                                await Api.getExcelLabels().then((excelLabels) => {
                                    this.setState({ allExcelLabels: excelLabels });
                                });
                                Api.getLabels().then((labels) => {
                                    this.setState({
                                        labelVisible: true,
                                        labels: labels
                                    });
                                });
                            }}
                            shape="round"
                            icon={<ExportOutlined />}
                            title="Export Label">
                            Label
                        </Button>
                    </div>
                    <div className="test-block-details">
                        {this.state.testBlockResults
                            .map((v) => (
                                <TestBlockResults key={v.id} testBlockResult={v} />
                            ))}
                    </div>
                </div>
            </Modal>
        );
    }
}

export default DataBrowserResultsModal;